import { call, select, put } from "redux-saga/effects"
import { getProfileId, getSelectedTeamMembership } from "../selectors"
import { GET_TEAM_ACCOUNT_CUSTOMER } from "../../util/customer_graphql_queries"
import { sendGraphqlRequest } from "../../api/graphQlClient"
import * as actions from "../action_creators"

import { ingressAccountAndValidCustomer } from "../../util/account_customer_utils"

export function* handleFetchTeamAccountCustomer({ teamId }) {
    if (!teamId) return

    const resp = yield call(
        sendGraphqlRequest,
        GET_TEAM_ACCOUNT_CUSTOMER(teamId),
    )
    // destructure customer object from nested resp: team -> account -> customer
    const {
        team: { account },
    } = resp

    // destructure customers and grab the only customer in the customers array
    // the customers graphql query returns all customers
    yield call(ingressAccountAndValidCustomer, account)
}

export function* handleWebsocketCustomerUpdated(ownerId) {
    const currentUserId = yield select(getProfileId)
    const { teamId } = yield select(getSelectedTeamMembership)

    // check to see if current user id matches the account owner
    if (currentUserId === ownerId.id) {
        yield put(actions.fetchTeamAccountCustomer(teamId))
    }
}

export function* handleWebsocketAccountsUpdated(ownerId) {
    const currentUserId = yield select(getProfileId)
    const { teamId } = yield select(getSelectedTeamMembership)

    // check to see if current user id matches the account owner
    if (currentUserId === ownerId.id) {
        yield put(actions.fetchTeamAccountCustomer(teamId))
    }
}


// WEBPACK FOOTER //
// ./src/redux/sagas/customer_sagas.js